module.exports = __webpack_public_path__ + "img/bingo_ball-49.bbae56e8.png";